import React from 'react';
import '../styles/FinishChip.css';
import { HugeiconsIcon } from '@hugeicons/react';
import { GoogleGeminiIcon } from '@hugeicons/core-free-icons';
import { colour } from '../styles/GlobalStyles';

function FinishChip(props) {
    const label = props.label;
    const level = props.level;
    return (
        <div className={"finish-chip-outer-container " + (level === 0 ? "finish-chip-lipstick" : level === 1 ? "finish-chip-mid-tier" : "finish-chip-luxury")}>
            <div className="finish-chip-inner-container">
                <HugeiconsIcon
                    icon={GoogleGeminiIcon}
                    size={13}
                    color={level === 0 ? colour.red02 : level === 1 ? colour.blue02 : colour.green02}
                />
                <span className="body-regular colour-primary">
                    {label}
                </span>
            </div>
        </div>
    )
};

export default FinishChip;